// FHxD App - Four Hundred by Design
import { Routes, Route, useSearchParams } from 'react-router-dom';
import { ThemeProvider, themeClasses } from '@member-portal/ui';
import { AuthProvider } from '@/contexts/AuthContext';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SplitLandingPage from '@/pages/SplitLandingPage';
import PartnerLandingPage from '@/pages/PartnerLandingPage';
import PartnerConnectPage from '@/pages/PartnerConnectPage';
import PartnerOpportunitiesPage from '@/pages/PartnerOpportunitiesPage';
import AdvisorLandingPage from '@/pages/AdvisorLandingPage';
import AdvisorConnectPage from '@/pages/AdvisorConnectPage';
import AdvisorOpportunitiesPage from '@/pages/AdvisorOpportunitiesPage';
import AboutPage from '@/pages/AboutPage';
import HotelsPage from '@/pages/HotelsPage';
import HotelDetail from '@/pages/HotelDetail';
import MediaPage from '@/pages/MediaPage';
import InsiderPage from '@/pages/InsiderPage';
import TermsPage from '@/pages/TermsPage';
import PrivacyPage from '@/pages/PrivacyPage';
import FAQPage from '@/pages/FAQPage';
import ContactPage from '@/pages/ContactPage';
import SignupPage from '@/pages/SignupPage';
import LoginPage from '@/pages/LoginPage';
import AdminLoginPage from '@/pages/AdminLoginPage';
import ScrollToTop from '@/components/ScrollToTop';
import UrlRedirectHandler from '@/components/UrlRedirectHandler';

function AppContent() {
  const [searchParams] = useSearchParams();
  const isShareView = searchParams.get('share') === 'true';

  return (
    <div className={`min-h-screen flex flex-col ${themeClasses.page}`}>
      <ScrollToTop />
      <UrlRedirectHandler />
      {!isShareView && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<SplitLandingPage />} />
          <Route path="/for-partners" element={<PartnerOpportunitiesPage source="for-partners" />} />
          <Route path="/partner-connect" element={<PartnerConnectPage />} />
          <Route path="/partner-opportunities" element={<PartnerOpportunitiesPage />} />
          <Route path="/connect" element={<PartnerLandingPage />} />
          <Route path="/for-advisors" element={<AdvisorLandingPage />} />
          <Route path="/advisor-connect" element={<AdvisorConnectPage />} />
          <Route path="/advisor-opportunities" element={<AdvisorOpportunitiesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/collection" element={<HotelsPage />} />
          <Route path="/collection/:hotelId" element={<HotelDetail />} />
          <Route path="/insider" element={<InsiderPage />} />
          <Route path="/press" element={<MediaPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin-login" element={<AdminLoginPage />} />
        </Routes>
      </main>
      {!isShareView && <Footer />}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider initialTheme="light">
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
